import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { PolicyNumberControlProps } from './PolicyNumberControl.interfaces';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useTextControl } from 'app/shared/hooks/controls/useTextControl';
import { isValidPolicyNumber } from 'app/validators/validatePolicyNumber';

const getUpperCasedValue = (value: string) => {
  return value.toUpperCase();
};

export default function PolicyNumberControl(props: PolicyNumberControlProps) {
  const {
    disabled,
    helperText,
    input,
    label,
    meta,
    subLabel,
    tooltip,
    width,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    isValueCheckVisible,
    onFocus,
  } = useTextControl(props, {
    charValidation: isValidPolicyNumber,
    valueNormalize: getUpperCasedValue,
  });

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      helperText={helperText}
      isQuestionValid={props.isQuestionValid}
      floating
      floated={focused || UtilService.hasValue(input.value)}
      meta={meta}
      focused={focused}
      width={width}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          label={subLabel ? `${label} - ${subLabel}` : label}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={onFocus}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          InputProps={{
            startAdornment: isValueCheckVisible && <DoneAdornment />,
          }}
          error={error}
          variant={'outlined'}
          margin={'dense'}
          disabled={disabled}
        />
      </FormControl>
    </ControlContainer>
  );
}
